const SHIPPING_METHODS_LOAD = "checkout/shippingMethods/SHIPPING_METHODS_LOAD";
const SHIPPING_METHODS_SUCCESS = "checkout/shippingMethods/SHIPPING_METHODS_SUCCESS";
const SHIPPING_METHODS_FAILED = "checkout/shippingMethods/SHIPPING_METHODS_FAILED";
const shippingMethodsSuccess = (payload) => ({
  type: SHIPPING_METHODS_SUCCESS,
  payload
});
const shippingMethodsFailed = (error) => ({
  type: SHIPPING_METHODS_FAILED,
  error
});
export {
  SHIPPING_METHODS_FAILED,
  SHIPPING_METHODS_LOAD,
  SHIPPING_METHODS_SUCCESS,
  shippingMethodsFailed,
  shippingMethodsSuccess
};
//# sourceMappingURL=actions.js.map
